export default __webpack_public_path__ + "static/media/visual2.7534acc0.png";